// ADR-133: Reports → Ingestion Sync Runs. Reuses the Direct Representative
// Discrepancy Audit styles so both list/detail reports look the same.
import styled from 'styled-components';
import { COLORS } from '../../../constants/radar';

export {
  FilterBar,
  TableWrapper,
  SummaryGrid,
  SummaryTile,
  SummaryLabel,
  SummaryValue,
  SummaryMeta,
  LoadMoreButton,
  TwoLine,
  TwoLinePrimary,
  TwoLineSecondary,
  RunRow,
} from '../DirectManagerDiscrepancies/styles';

// A batch's later steps sit visually under its first step on the list page.
export const BatchContinuationCell = styled.td`
  padding-left: 28px !important;
  color: ${COLORS.SECONDARY};
`;

export const StepsRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
`;

export const LinkButton = styled.button`
  background: none;
  border: none;
  padding: 0;
  color: ${COLORS.PRIMARY};
  font: inherit;
  font-weight: 500;
  text-align: left;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;
